import React from 'react';

import packageJson from '../../../package.json';
import { Typography } from '../../UI/Typography';
import { IS_STAGING } from '../../constants/general';

export const Version: React.FC = () => {
  const branchName = process.env.REACT_APP_GIT_BRANCH;

  return (
    <Typography variant="caption">
      v{packageJson.version}
      {IS_STAGING && branchName && ` (${branchName})`}
    </Typography>
  );
};
